import { createAsyncThunk } from '@reduxjs/toolkit'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { calculateDefaultUnit } from '../../../../../../common/selectCurrencyUnit/slice'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'
import { mapAllVNDValue } from '../../../helper'

export const getSecuCashBreakdownThunk = createAsyncThunk(
  'financialAnalysis/Secu/GET_CASH_BREAKDOWN',
  async (data, { rejectWithValue, dispatch }) => {
    const response = await FinancialAnalysisService.getCashBreakdown(data)
    if (response.success) {
      dispatch(
        calculateDefaultUnit({
          screen: SCREEN.FINANCIAL_ANALYSIS,
          getValues: () => mapAllVNDValue(response.data),
        }),
      )
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadSecuCashBreakdown = createAsyncThunk(
  'financialAnalysis/Secu/DOWNLOAD_CASH_BREAKDOWN',
  async (data) => {
    const response = await FinancialAnalysisService.downloadCashBreakdown(data)
    handleExport(response.data, response.filename)
  },
)
